<template>
    <div class="header-additional-actions">
        <div class="header-additional-desktop">
            <ClientOnly>
                <UserRegion class="additional-action" />
            </ClientOnly>
            <div class="additional-action">
                <nuxt-img
                    src="icons/location-branches.svg"
                    class="additional-action__icon"
                    alt=""
                />
                <n-link
                    to="/about/offices-and-atms"
                    class="header-additional-desktop__link"
                >
                    Офисы и банкоматы
                </n-link>
            </div>
            <div class="additional-action">
                <a
                    href="https://centrinvest.com/"
                    class="header-additional-desktop__link"
                >
                    En
                </a>
            </div>
            <div class="additional-action">
                <a
                    href="https://centrinvest.com/cn"
                    class="header-additional-desktop__link"
                >
                    Zh
                </a>
            </div>
            <BankServicesDropdown />
        </div>
        <div class="header-additional-mobile">
            <BankServicesDropdown is-mobile />
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import UserRegion from '@/components/UserRegions/UserRegion.vue';
import BankServicesDropdown from '@/components/Sections/Header/BankServicesDropdown.vue';

export default defineComponent({
    name: 'HeaderAdditionalActions',
    components: {
        UserRegion,
        BankServicesDropdown,
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/cibButton';
@import '@/assets/styles/common/header/header-additional-actions';
</style>
